import CloseIcon from "@mui/icons-material/Close";
import {
  Card,
  Checkbox,
  ClickAwayListener,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  MenuList,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import Popper from "@mui/material/Popper";
import { styled } from "@mui/material/styles";
import * as React from "react";
import PlacesAutocomplete from "react-places-autocomplete";
import {
  GetRecruiters,
} from "../../../../Services/recruiterService";
import { defaultSelectAutoComplete } from "../../../../data/defaultDataAutocomplete";
import { Industry } from "../../../../models/app/AppModels";
import getAddressForAutoComplete from "../../../../utils/getAddressForAutoComplete";
import getUnique from "../../../../utils/getUnique";
import getUniqueLocationForAutoComplete from "../../../../utils/getUniqueLocationFromAutoComplete";
import { CheckBoxSquareIcon } from "../../../Common/CheckBoxSquareIcon";
import { useSelector } from "react-redux";
import { GetCandidateByFilter } from "../../../../Services/candidateService";
import getLoggedInUserRole from "../../../../Shared/utils/getLoggedInUserRole";
import getUserDetails from "../../../../Shared/utils/getUserDetails";
import { RecruiterStatus, UserAuth } from "../../../../models/interfaces";
import constructName from "../../../../utils/constructName";
import { valueOrDefault } from "../../../../utils/complexityUtils";
function generateExperienceArray(yearsOfExperience: number) {
      // Generate an array of experience objects
      const experienceArray = [];
 
      for (let i = 1; i <= yearsOfExperience; i++) {
        experienceArray.push({
          id: i,
          experience: `${i} years`,
          experienceValue: `${i}`,
        });
 
        if (i === yearsOfExperience) {
          experienceArray.push({
            id: i + 1,
            experience: `${i}+ years `,
            experienceValue: `${i}+`,
          });
        }
      }
      return experienceArray;
    }


const Wrapper = styled("div")({
  fontFamily: "Roboto !important !important",
});

interface FilterProps {
  anchorFilter: any;
  onClose: (event: any) => void;
  onChange: (locations: string[]) => void;
  onExperinceChange: (industries: Industry[]) => void;
  handleCandiateChange: (domains: string[]) => void;
  handleRecruiterChange: (skills: string[]) => void;
  selectedLocations: any[];
  selectedExperinces: Industry[];
  selectedCandidate: string[];
  selectedRecruiter: string[];
}

export interface FilterRef {
  handleClearAll: () => void;
}

const CandidateListFilters = (
  props: React.PropsWithChildren<FilterProps>, 
  ref: React.ForwardedRef<FilterRef>
) => {
  const { anchorFilter } = props;
  const open = Boolean(anchorFilter);
  const locationInputRef = React.useRef(null);
  const [value, setValue] = React.useState(0);
  const [selectedLocations, setLocationsSelected] = React.useState(
    props.selectedLocations
  );

  const [search, setSearch] = React.useState("");
  const [candidateSearch, setCandidateSearch] = React.useState("");
  const [recruiterSearch, setRecruiterSearch] = React.useState("");

  const [selectedExperinces, setselectedExperince] = React.useState(
    props.selectedExperinces
  );
  const [selectedCandidates, setselectedCandidates] = React.useState<
    string[]
  >(props.selectedCandidate);
  const [selectedRecruiters, setSelectedRecruiters] = React.useState<
    string[]
  >(props.selectedRecruiter);

  // Lists
  let jobWorkExperiencesList = generateExperienceArray(50);
  const [candidateFilterList, setCandidateFilterList] = React.useState<any>(
    []
  );
  const [recruiterFilterList, setRecruiterFilterList] = React.useState<any>(
    []
  );
  const userRole = getLoggedInUserRole();
  const user = getUserDetails();
  const {
    candidateFilter
  } = useSelector((state: any) => state.candidateReducer);

  const adminRoles = new Set([UserAuth.Admin, UserAuth.SuperAdmin]);
  const isAdminAndSuperAdmin = adminRoles.has(userRole);

  const initialCandidateFilterState = {
    recruiterId: userRole == UserAuth.Recruiter ? user?.id : "",
    searchKeywords: "",
    location: [],
    experience: [],
    workAuthorizationStatuses: [],
    skills: [],
    payRate: "",
    contractStatus: [],
    pageIndex: 1,
    pageSize: 5,
    sortColumn: "",
    sortOrder: "Descending",
    isSorted: true,
    totalRecord: 0,
    candidateGuids: candidateFilter?.candidateGuids ?? [],
    recruiterGuids: candidateFilter?.recruiterGuids ?? [],
  };

  const [filterState, setfilterState] = React.useState(
    initialCandidateFilterState
  );

  const [data, setData] = React.useState({
    pageIndex: 1,
    pageSize: 5,
    sortColumn: "DateSignedUp",
    sortOrder: "Descending",
    isSorted: true,
    totalRecord: 0,
    searchKeywords: "",
    status: [RecruiterStatus[1]],
    filterByMasterData: {
      locationFilterInputs: [],
      domainFilterInputs: [],
      industryFilterInputs: [],
      skillsFilterInputs: [],
    },
  });

  // Get Master candidate list
  const _GetCandidateList = () => {
    GetCandidateByFilter({
      ...filterState,
      recruiterId: userRole === UserAuth.Recruiter ? user?.id : "",
    })
      ?.then((response: any) => {
        if (response?.data?.message?.appStatusCode === "RC_RSF") {
          setCandidateFilterList(response?.data?.entityList);
        } else {
          setCandidateFilterList([]);
        }
      })
      .catch((error) => {
        console.log(error); 
      });
  };

  const _GetRecruiterList = () => {
    GetRecruiters(data)
      ?.then((response: any) => {
        if (response?.data?.message?.appStatusCode === "RC_RSF") {
          setRecruiterFilterList(response?.data?.entityList);
        } else {
          setRecruiterFilterList([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };


  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [autoSuggestions, setautoSuggestions] = React.useState(
    defaultSelectAutoComplete
  );

  const loadSuggestions = (sugg: any) => {
    if (sugg.length > 0) {
      setautoSuggestions(sugg);
    }
  };

  const getCity = (description: any) => {
    let city = getAddressForAutoComplete(description).city;

    return city;
  };

  let locationLists = getUnique(
    selectedLocations?.concat(
      getUniqueLocationForAutoComplete(autoSuggestions)
    ),
    "placeId"
  );

  let Experinces =
    selectedExperinces?.length > 0
      ? selectedExperinces.concat(jobWorkExperiencesList)
      : jobWorkExperiencesList;

  const uniqueExperinces = getUnique(Experinces);

  let candidateListFilter =
    selectedCandidates?.length > 0
      ? selectedCandidates.concat(candidateFilterList)
      : candidateFilterList;

  const uniqueCandidateFilterList = getUnique(candidateListFilter);

  let skills =
    selectedRecruiters?.length > 0
      ? selectedRecruiters.concat(recruiterFilterList)
      : recruiterFilterList;

  const uniqueRecruiterFilterList = getUnique(skills);

  const handleLocationChange = (e: any, location: any) => {
    let isChecked = e.target.checked;
    if (isChecked) {
      setLocationsSelected([...selectedLocations, location]);
    } else {
      setLocationsSelected(
        selectedLocations.filter((item) => item.placeId !== location.placeId)
      );
    }
  };

  const handleExperienceChange = (e: any, experience: any) => {
    let isChecked = e.target.checked;
    if (isChecked) {
      setselectedExperince([...selectedExperinces, experience]);
    } else {
      setselectedExperince(
        selectedExperinces.filter((item) => item.id !== experience?.id)
      );
    }
  };

  const _handleCandidateChange = (e: any, selectedcandidate: any) => {
    let isChecked = e.target.checked;
    if (isChecked) {
      setselectedCandidates([...selectedCandidates, selectedcandidate]);
    } else {
      setselectedCandidates(
        selectedCandidates.filter(
          (item: any) => item.id !== selectedcandidate?.id
        )
      );
    }
  };

  const _handleRecruiterChange = (e: any, selectedRecruiter: any) => {
    let isChecked = e.target.checked;
    if (isChecked) {
      setSelectedRecruiters([...selectedRecruiters, selectedRecruiter]);
    } else {
      setSelectedRecruiters(
        selectedRecruiters.filter(
          (item: any) => item.id !== selectedRecruiter?.id
        )
      );
    }
  };

  const handleSearchCandidate = (searchText: string) => {
    setfilterState({
      ...filterState,
      searchKeywords: searchText,
    });
    setCandidateSearch(searchText);
  };

  const handleSearchRecruiter = (searchText: string) => {
    setData({
      ...data,
      searchKeywords: searchText,
    });
    setRecruiterSearch(searchText);
  };

  React.useEffect(() => {
    _GetCandidateList();
  }, [filterState.searchKeywords]);

  React.useEffect(() => {
    if(isAdminAndSuperAdmin)
    _GetRecruiterList();
  }, [data.searchKeywords]);

  React.useEffect(() => {
    props.onChange(selectedLocations);
  }, [selectedLocations]);

  React.useEffect(() => {
    props?.onExperinceChange(selectedExperinces);
  }, [selectedExperinces]);

  React.useEffect(() => {
    props?.handleCandiateChange(selectedCandidates);
  }, [selectedCandidates]);

  React.useEffect(() => {
    props?.handleRecruiterChange(selectedRecruiters);
  }, [selectedRecruiters]);

  const handleClearLocations = () => {
    setLocationsSelected([]);
    setSearch("");
    setautoSuggestions(defaultSelectAutoComplete);
  };

  const handleClearExperince = () => {
    setselectedExperince([]);
  };

  const handleClearCandidate = () => {
    setCandidateSearch("");
    setselectedCandidates([]);
    setfilterState({
      ...filterState,
      searchKeywords: "",
      candidateGuids: [],
    });
  };

  const handleClearRecruiter = () => {
    setData({
      ...data,
      searchKeywords: "",
    });
    setRecruiterSearch("");
    setSelectedRecruiters([]);
    setfilterState({
      ...filterState,
      searchKeywords: "",
      recruiterGuids: [],
    });   
    
  };

  const handleClearAll = () => {
    handleClearLocations();
    handleClearExperince();
    handleClearCandidate();
    handleClearRecruiter();
  };

  React.useImperativeHandle(ref, () => ({
    handleClearAll,
  }));

  return (
    <Wrapper>
      <Popper
        id={"id"}
        open={open}
        anchorEl={anchorFilter}
        placement="bottom"
      >
        <ClickAwayListener onClickAway={props.onClose}>
          <Card>
            <Box
              sx={{
                flexGrow: 1,
                bgcolor: "#FAFAFA",
                display: "flex",
              }}
            >
              <Grid container p={2}>
                <Grid item md={6}>
                  <Typography fontWeight={"bold"} className="roboto-font custom-candidatefilter-font">
                    Filters
                  </Typography>
                </Grid>
                <Grid item xs={6} className="closeArea">
                  <IconButton
                    aria-label="close"
                    size="small"
                    className="close-Btn"
                    onClick={props.onClose}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                bgcolor: "#FAFAFA",
                display: "flex",
                height: 386,
              }}
            >
              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                sx={{ borderRight: 1, borderColor: "divider", width: 146 }}
              >
                <Tab
                  data-testid="location-tab"
                  className="filterTabNav"
                  label={
                    <Typography
                      fontSize={16}
                      className="roboto-font"
                    >
                      Location
                    </Typography>
                  }
                  {...a11yProps(0)}
                  style={{
                    backgroundColor: value === 0 ? "white" : "inherit",
                    alignItems: "flex-start",
                  }}
                />
                <Tab
                  data-testid="Experience-tab"
                  className="filterTabNav"
                  label={
                    <Typography
                      fontSize={16}
                      className="roboto-font"
                    >
                      Experience
                    </Typography>
                  }
                  {...a11yProps(1)}
                  style={{
                    backgroundColor: value === 1 ? "white" : "inherit",
                    alignItems: "flex-start",
                  }}
                />
                {/* Candidate Tab */}
                <Tab
                  data-testid="Candidate-tab"
                  className="filterTabNav"
                  label={
                    <Typography
                      fontSize={16}
                      className="roboto-font"
                    >
                      Candidate
                    </Typography>
                  }
                  {...a11yProps(2)}
                  style={{
                    backgroundColor: value === 2 ? "white" : "inherit",
                    alignItems: "flex-start",
                  }}
                />
                {/* Recruiter Tab */}
                {userRole === UserAuth.Admin ||
                userRole === UserAuth.SuperAdmin ? (
                  <Tab
                    data-testid="Recruiter-tab"
                    className="filterTabNav"
                    label={
                      <Typography
                        fontSize={16}
                        className="roboto-font"
                      >
                        Recruiter
                      </Typography>
                    }
                    {...a11yProps(3)}
                    style={{
                      backgroundColor: value === 3 ? "white" : "inherit",
                      alignItems: "flex-start",
                    }}
                  />
                ) : (
                  ""
                )}
              </Tabs>
              <TabPanel value={value} index={0}>
                <PlacesAutocomplete
                  data-testid="place-autocomplete"
                  searchOptions={{ types: ["(cities)"] }}
                  ref={locationInputRef}
                  value={search}
                  onChange={(ev: any) => {
                    if (!ev) {
                      setautoSuggestions(defaultSelectAutoComplete);
                    }
                    setSearch(ev);
                  }}
                >
                  {({ getInputProps, suggestions }: any) => {
                    loadSuggestions(suggestions);
                    return (
                      <Grid container style={{ width: 223 }} p={2}>
                        <Grid item md={12}>
                          <Grid container>
                            <Grid item>
                              <TextField
                                className="roboto-font filter-searchbox"
                                placeholder="Search Location"
                                size="small"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end" sx={{marginRight:"10px"}}>                              
                                        <svg
                                          width="20"
                                          height="20"
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M9.16675 1.66666C13.3067 1.66666 16.6667 5.02666 16.6667 9.16666C16.6667 13.3067 13.3067 16.6667 9.16675 16.6667C5.02675 16.6667 1.66675 13.3067 1.66675 9.16666C1.66675 5.02666 5.02675 1.66666 9.16675 1.66666ZM9.16675 15C12.3892 15 15.0001 12.3892 15.0001 9.16666C15.0001 5.94333 12.3892 3.33333 9.16675 3.33333C5.94341 3.33333 3.33341 5.94333 3.33341 9.16666C3.33341 12.3892 5.94341 15 9.16675 15ZM16.2376 15.0592L18.5951 17.4158L17.4159 18.595L15.0592 16.2375L16.2376 15.0592V15.0592Z"
                                            fill="#353535"
                                          />
                                        </svg>
                                    </InputAdornment>
                                  ),
                                }}
                                {...getInputProps()}
                              />
                            </Grid>
                            <Grid item pt={1} pb={0.5}>
                              <FormControlLabel
                                data-testid={"clearLocationBtn"}
                                onClick={handleClearLocations}
                                control={
                                  <CheckBoxSquareIcon
                                    style={{ paddingRight: "5px" }}
                                  ></CheckBoxSquareIcon>
                                }
                                label={
                                  <Typography
                                    fontSize={14}
                                    className="roboto-font"
                                  >
                                    Clear All
                                  </Typography>
                                }
                                className="candidates-label roboto-font"
                                style={{
                                  color: "red",
                                  fontWeight: "bold",
                                  paddingLeft: 0,
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          md={12}
                          style={{ maxHeight: 300, overflowY: "auto" }}
                        >
                          <MenuList
                            style={{ paddingTop: "0px" }}
                            className="listing-filter"
                          >
                            <MenuItem
                              sx={{
                                paddingLeft: "0px",
                                paddingBottom: "0px",
                                minHeight: "auto",
                              }}
                            ></MenuItem>
                            {locationLists.map(
                              (suggestion: any, index: number) => {
                                let state = valueOrDefault(
                                  suggestion?.formattedSuggestion?.secondaryText?.split(",")[0],
                                  ""
                                );
                                let city = getCity(suggestion?.description);
                                  
                                if (city !== undefined)
                                  return (
                                    <MenuItem
                                      key={suggestion?.placeId ?? index}
                                      sx={{
                                        paddingLeft: "0px",
                                        paddingBottom: "0px",
                                        minHeight: "auto",
                                      }}
                                    >
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            data-testid="location-checkbox"
                                            onChange={(e) =>
                                              handleLocationChange(
                                                e,
                                                suggestion
                                              )
                                            }
                                            checked={selectedLocations.includes(
                                              suggestion
                                            )}
                                            name={city}
                                            sx={{
                                              padding: "0px",
                                              fontSize: "14px",
                                            }}
                                          />
                                        }
                                        label={
                                          <Typography
                                            fontSize={14}
                                            className="roboto-font"
                                          >
                                            {city + ", " + state}
                                          </Typography>
                                        }
                                        className="candidates-label roboto-font"
                                        style={{ paddingLeft: 0 }}
                                      />
                                    </MenuItem>
                                  );
                              }
                            )}
                          </MenuList>
                        </Grid>
                      </Grid>
                    )
                  }}
                </PlacesAutocomplete>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <Grid container style={{ width: 223 }} p={2}>
                  <Grid item md={12}>
                    <Grid container>                      
                      <Grid item pt={1} pb={0.5}>
                        <FormControlLabel
                          data-testid={"clearExpBtn"}
                          onClick={handleClearExperince}
                          control={
                            <CheckBoxSquareIcon
                              style={{ paddingRight: "5px" }}
                            ></CheckBoxSquareIcon>
                          }
                          label={
                            <Typography fontSize={14} className="roboto-font">
                              Clear All
                            </Typography>
                          }
                          className="candidates-label"
                          style={{
                            color: "red",
                            fontWeight: "bold",
                            paddingLeft: 0,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    style={{ maxHeight: 300, overflowY: "auto" }}
                  >
                    <MenuList
                      style={{ paddingTop: "0px" }}
                      className="listing-filter"
                    >
                      <MenuItem
                        sx={{
                          paddingLeft: "0px",
                          paddingBottom: "0px",
                          minHeight: "auto",
                        }}
                      ></MenuItem>
                      {uniqueExperinces?.map((item: any, index: any) => {
                        return (
                          <MenuItem
                            key={item?.id ?? index}
                            sx={{
                              paddingLeft: "0px",
                              paddingBottom: "0px",
                              minHeight: "auto",
                            }}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  data-testid={`experince-checkbox-${index}`}
                                  onChange={(e) =>
                                    handleExperienceChange(e, item)
                                  }
                                  name={item?.id}
                                  sx={{ padding: "0px", fontSize: "14px" }}
                                  checked={selectedExperinces?.includes(item)}
                                />
                              }
                              label={
                                <Typography
                                  fontSize={14}
                                  className="roboto-font"
                                >
                                  {item?.experience}
                                </Typography>
                              }
                              className="candidates-label roboto-font"
                              style={{ paddingLeft: 0 }}
                            />
                          </MenuItem>
                        );
                      })}
                    </MenuList>
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value={value} index={2}>
                <Grid container style={{ width: 223 }} p={2}>
                  <Grid item md={12}>
                    <Grid container>
                      <Grid item>
                        <TextField
                          className="roboto-font filter-searchbox"
                          placeholder="Search Candidate"
                          size="small"
                          value={candidateSearch}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end" sx={{marginRight:"10px"}}>                              
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M9.16675 1.66666C13.3067 1.66666 16.6667 5.02666 16.6667 9.16666C16.6667 13.3067 13.3067 16.6667 9.16675 16.6667C5.02675 16.6667 1.66675 13.3067 1.66675 9.16666C1.66675 5.02666 5.02675 1.66666 9.16675 1.66666ZM9.16675 15C12.3892 15 15.0001 12.3892 15.0001 9.16666C15.0001 5.94333 12.3892 3.33333 9.16675 3.33333C5.94341 3.33333 3.33341 5.94333 3.33341 9.16666C3.33341 12.3892 5.94341 15 9.16675 15ZM16.2376 15.0592L18.5951 17.4158L17.4159 18.595L15.0592 16.2375L16.2376 15.0592V15.0592Z"
                                      fill="#353535"
                                    />
                                  </svg>
                              </InputAdornment>
                            ),
                          }}
                          onChange={(
                            event: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            handleSearchCandidate(event.target.value);
                          }}
                        />
                      </Grid>
                      <Grid item pt={1} pb={0.5}>
                        <FormControlLabel
                          data-testid={"clearCandidateListButton"}
                          onClick={handleClearCandidate}
                          control={
                            <CheckBoxSquareIcon
                              style={{ paddingRight: "5px" }}
                            ></CheckBoxSquareIcon>
                          }
                          label={
                            <Typography fontSize={14} className="roboto-font">
                              Clear All
                            </Typography>
                          }
                          className="candidates-label"
                          style={{
                            color: "red",
                            fontWeight: "bold",
                            paddingLeft: 0,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    style={{ maxHeight: 300, overflowY: "auto" }}
                  >                      
                    {uniqueCandidateFilterList?.map(
                      (item: any, index: number) => {
                        return (
                          <FormControl fullWidth  key={item?.id ?? index}>
                            <FormControlLabel                             
                              control={
                                <Checkbox
                                  className="taxtermsCheckboxItem"
                                  onChange={(e) =>
                                    _handleCandidateChange(e, item)
                                  }
                                  name={item}
                                  sx={{ padding: "0px", fontSize: "14px" }}
                                  checked={selectedCandidates.includes(item)}
                                  data-testid={`candidateList${index}`}
                                />
                              }
                              label={
                                <Typography
                                  fontSize={14}
                                  className="roboto-font"
                                >
                                  {constructName(
                                    item?.firstName,
                                    item?.lastName
                                  )}
                                </Typography>
                              }
                              className="candidates-label roboto-font"
                              style={{ paddingLeft: 0 }}
                            />
                          </FormControl>
                        );
                      }
                    )}
                  </Grid>
                </Grid>
              </TabPanel>

              <TabPanel value={value} index={3}>
                <Grid container style={{ width: 223 }} p={2}>
                  <Grid item md={12}>
                    <Grid container>
                      <Grid item>
                        <TextField
                          className="roboto-font filter-searchbox"
                          placeholder="Search Recruiter"
                          size="small"
                          value={recruiterSearch}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end" sx={{marginRight:"10px"}}>                              
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M9.16675 1.66666C13.3067 1.66666 16.6667 5.02666 16.6667 9.16666C16.6667 13.3067 13.3067 16.6667 9.16675 16.6667C5.02675 16.6667 1.66675 13.3067 1.66675 9.16666C1.66675 5.02666 5.02675 1.66666 9.16675 1.66666ZM9.16675 15C12.3892 15 15.0001 12.3892 15.0001 9.16666C15.0001 5.94333 12.3892 3.33333 9.16675 3.33333C5.94341 3.33333 3.33341 5.94333 3.33341 9.16666C3.33341 12.3892 5.94341 15 9.16675 15ZM16.2376 15.0592L18.5951 17.4158L17.4159 18.595L15.0592 16.2375L16.2376 15.0592V15.0592Z"
                                      fill="#353535"
                                    />
                                  </svg>
                              </InputAdornment>
                            ),
                          }}
                          onChange={(
                            event: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            handleSearchRecruiter(event.target.value);
                          }}
                        />
                      </Grid>
                      <Grid item pt={1} pb={0.5}>
                        <FormControlLabel
                          data-testid={"clearRecruiterBtn"}
                          onClick={handleClearRecruiter}
                          control={
                            <CheckBoxSquareIcon
                              style={{ paddingRight: "5px" }}
                            ></CheckBoxSquareIcon>
                          }
                          label={
                            <Typography fontSize={14} className="roboto-font">
                              Clear All
                            </Typography>
                          }
                          className="candidates-label"
                          style={{
                            color: "red",
                            fontWeight: "bold",
                            paddingLeft: 0,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    style={{ maxHeight: 300, overflowY: "auto" }}
                  >
                    {uniqueRecruiterFilterList?.map(
                      (item: any, index: any) => {
                        return (
                          <FormControl fullWidth  key={item?.id ?? index}>
                            <FormControlLabel                             
                              control={
                                <Checkbox
                                  className="taxtermsCheckboxItem"
                                  onChange={(e) =>
                                    _handleRecruiterChange(e, item)
                                  }
                                  name={item}
                                  sx={{ padding: "0px", fontSize: "14px" }}
                                  checked={selectedRecruiters?.includes(item)}
                                  data-testid={`recruiterList${index}`}
                                />
                              }
                              label={
                                <Typography
                                  fontSize={14}
                                  className="roboto-font"
                                >
                                  {constructName(
                                    item?.firstName,
                                    item?.lastName
                                  )}
                                </Typography>
                              }
                              className="candidates-label roboto-font"
                              style={{ paddingLeft: 0 }}
                            />
                          </FormControl>
                        );
                      }
                    )}
                  </Grid>
                </Grid>
              </TabPanel>
            </Box>
          </Card>
        </ClickAwayListener>
      </Popper>
    </Wrapper>
  );
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ backgroundColor: "white" }}
    >
      {value === index && (
        <Typography className="roboto-font">{children}</Typography>
      )}
    </div>
  );
}

export default React.forwardRef(CandidateListFilters);
